<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [noBow]="true"
      [canGoBack]="true"
      [title]="'Edit Report Name'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav; context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav; context:{ extraClass: 'desktop' }" />
    @if (loaded) {
      <tidy-card>
        <form [formGroup]="form" novalidate action="#">
          <tidy-row class="field-top-padding">
            <tidy-input
              [label]="'Report Name'"
              [icon]="'assets/svg/information-circle.svg'"
              [form]="form.controls.name"
              formControlName="name"
              [submitted]="submitted"
              [errorMessage]="'Please enter a name.'" />
          </tidy-row>
        </form>
      </tidy-card>
      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }
      <tidy-button
        [action]="boundSaveName"
        [text]="'Save Name'"
        class="primary" />
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
